export const convertDataToApi = (data: any) => ({
  preview: data.preview || null,
  name: data.name,
  language: data.language ? data.language.value : null,
});
